/*
 * FICHIER: index.js
 * BUT: Point d'entrée principal de l'application React OffiSport
 * 
 * Ce fichier est le premier à s'exécuter quand l'application démarre.
 * Il crée la racine de l'application React et l'attache au DOM HTML.
 */

// Import de React - La bibliothèque principale pour créer des interfaces utilisateur
import React from 'react';

// Import de ReactDOM - Permet de connecter React au navigateur web (DOM = Document Object Model)
import ReactDOM from 'react-dom/client';

// Import des styles CSS globaux de l'application
import './index.css';

// Import du composant principal App qui contient toute notre application
import App from './App';

// Création de la racine React - On dit à React où s'attacher dans la page HTML
// document.getElementById('root') trouve l'élément HTML avec id="root" dans public/index.html
const root = ReactDOM.createRoot(document.getElementById('root'));

// Rendu de l'application dans le navigateur
root.render(
  // React.StrictMode active des vérifications supplémentaires en développement
  // pour détecter les problèmes potentiels dans le code
  <React.StrictMode>
    {/* Le composant App contient toute notre application */}
    <App />
  </React.StrictMode>
);
